import { css } from "@emotion/react";

import { ButtonWrapper } from "components/shared/library/ButtonWrapper";
import { Divider } from "components/shared/library/Divider";
import { Typography } from "components/shared/library/Typography";

import { JobSearch } from "apis/jobs";

import { useJobSearch } from "utils/jobsSearch";

import { purple } from "constants/colors";

const style = {
  item: css({
    gap: 8,
    display: "flex",
    flexDirection: "column",
  }),
  button: css({
    gap: 8,
    display: "flex",
    flexDirection: "column",
    padding: 12,
    "&:hover": {
      background: purple[50],
      borderRadius: 8,
    },
  }),
  divider: css({
    margin: 0,
    width: "100%",
  }),
};

export const RecentJobSearchItem = ({
  jobSearch: { search: { value = "", filters = {} } = {} },
  isLast,
}: {
  jobSearch: JobSearch;
  isLast?: boolean;
}) => {
  const { upsertJobSearchFilter, upsertJobSearchValue } = useJobSearch();

  const { location, remote } = filters;
  const details =
    [location, remote].filter(Boolean).join(" · ") || "No filters";

  return (
    <div css={style.item}>
      <ButtonWrapper
        onClick={() => {
          if (value) upsertJobSearchValue(value);
          if (location) upsertJobSearchFilter("location", location);
          if (remote) upsertJobSearchFilter("remote", remote);
        }}
        customCss={style.button}
      >
        <Typography size="S" weight="bold">
          {value || "All jobs"}
        </Typography>
        <Typography>{details}</Typography>
      </ButtonWrapper>
      {!isLast && <Divider customCss={style.divider} />}
    </div>
  );
};
